import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Observable} from 'rxjs/internal/Observable';
import {HttpClient} from '@angular/common/http';
import { Constant } from '../constant';
import { Alert } from '../models/alert.model';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public alerts: BehaviorSubject<Alert[]> = new BehaviorSubject<Alert[]>([]);

  constructor(private http: HttpClient,
              private constant: Constant) {
  }

  emtyAlerts() {
    this.alerts.next([]);
  }

  public addAlert(alert: Alert): void {
    let getAlerts = this.alerts.value;
    if (!!!getAlerts.find(a => JSON.stringify(a) === JSON.stringify(alert))) {
      getAlerts.push(alert);
    }
    getAlerts = getAlerts.sort((a: any, b: any) => b.id - a.id);
    this.alerts.next(getAlerts);
  }

  public getNotifications(): Observable<any> {
    return this.http.get(`${this.constant.api}notifications`);
  }

  public deleteNotification(id: number): void {
    this.alerts.next(this.alerts.value.filter(item => item.id != id));
  }

  public readNotification(id: number): Observable<any> {
    return this.http.put(`${this.constant.api}notifications/read`, {
      id
    });
  }

  public getInfoForSignedDocument(id: number): Observable<any> {
    return this.http.get(`${this.constant.api}advances/${id}/sign`);
  }

  public getInfoForLeasingDocument(propertyId: number): Observable<any> {
    return this.http.get(`${this.constant.api}rental-process/${propertyId}/sing`);
  }

  public getCatalog(): Observable<any> {
    return this.http.get(`${this.constant.api}advances/catalogs`);
  }

  public completeWithCustomContract(form: any): Observable<any> {
    return this.http.post(`${this.constant.api}rental-process/complete-with-custom-contract`, form);
  }

  public completeInfoPropertyOwner(form: any): Observable<any> {
    return this.http.post(`${this.constant.api}rental-process/complete-info-property`, form);
  }

  public completeInfoPropertyTenant(form: any): Observable<any> {
    return this.http.post(`${this.constant.api}rental-process/complete-info-tenant`, form);
  }

  public isCompleteInfoProperty(propertyId: number): Observable<any> {
    return this.http.get(`${this.constant.api}rental-process/status-property/${propertyId}`);
  }

  public isCompleteInfoPropertyForTenant(propertyId: number): Observable<any> {
    return this.http.get(`${this.constant.api}rental-process/status-property-for-tenant/${propertyId}`);
  }

  public acceptCounteroffer(advanceId: number, notificationId: number): Observable<any> {
    return this.http.post(`${this.constant.api}advances/accept-counteroffer`, {
      advance_id: advanceId,
      notification_id: notificationId
    }, {
      observe: 'response'
    });
  }

  public confirmUbication(advanceId: number, latitude: number, longitude: number): Observable<any>
  {
    return this.http.put(`${this.constant.api}advances/confirm-ubication`, {
      advance_id: advanceId,
      latitude,
      longitude
    });
  }

}
